export default {
  root: {
    fontSize: '2rem'
  }
}
